import { Component, OnInit } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis, ApexYAxis } from 'ng-apexcharts';
import { forkJoin, Subject } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import DateUtils from 'src/app/utils/date';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[]
};
@Component({
  selector: 'app-deal-won-lost',
  templateUrl: './deal-won-lost.component.html',
  styleUrls: ['./deal-won-lost.component.css']
})
export class DealWonLostComponent implements OnInit {
  private unsubscribe = new Subject();
  id;
  type;
  won;
  lost;
  total;
  datas = [];
  monthsList;
  showGraph = false;
  mutipleSalespTeams;
  selectedIds = null;
  selectedType = null;
  selectedNames = null;
  dateUtil = new DateUtils;
  selectedPeriod = 'monthly'
  dataTable = [];
  selectedYr = new Date().getFullYear();

  public chartOptions = {
    series: [
      {
        name: "Total Deal",
        data: []
      },
      {
        name: "Deal Won",
        data: []
      },
      {
        name: "Deal Lost",
        data: []
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        // distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Months',
      },
    },
    yaxis: {
      title: {
        text: 'Number Of Deals',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
    colors: ["#0866C6", "#00c851", "#DC3545"],
  };

  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
  ) {
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type, names } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.selectedNames = names;
        this.handleDateFilter()
      }
    })
  }

  ngOnInit() {
    this.handleDateFilter();
  }

  handleDateFilter() {
    this.showGraph = false;
    this.getData();
  }

  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.handleDateFilter();
  }

  getData() {
    this.resetGraph();
    let id = this.selectedIds ? this.selectedIds.map(i => i.toString()) : null;
    let type = this.selectedType === "salesperson" ? 3 : this.selectedType === "team" ? 2 : null;
    const payload = { startDate: this.selectedYr, id: id, type: type || 3, };
    if (this.selectedIds && this.selectedIds.length > 1) {
      this.mutipleSelectedIds(payload);
    } else {
      this.singleSelectedIds(payload);
    }
  }

  singleSelectedIds(payload) {
    const dealWonLost = this.dealSrv.fetchTotalWonAndLostStats(payload)
    forkJoin([dealWonLost]).subscribe((responses: any) => {
      //map all the all variable into an array
      const all = responses[0].map(x => x.all);
      //sum the all array
      const allSum = all.reduce((a, b) => a + b)
      //if allSum is equals to zero the datas should be empty
      //else call the single data function
      if (allSum == 0) {
        this.datas = [];
        this.showGraph = true;
      } else {
        this.datas = responses;
        this.singleDataValue(this.datas);
      }
    })
  }

  mutipleSelectedIds(payload) {
    const dealWonLost = this.dealSrv.fetchSeparateTotalWonAndLostStats(payload);
    let totalSum = 0
    forkJoin([dealWonLost]).subscribe(([dealWonLostRes]) => {
      const quaters = ['Q1', 'Q2', 'Q3', 'Q4'];
      this.monthsList = this.selectedPeriod === 'quaterly' ? quaters : this.dateUtil.monthList;
      //map all the all variable into an array
      dealWonLostRes.forEach(deal => {
        const all = deal.values.map(t => t.all);
        //sum the all array
        const allSum = all.reduce((a, b) => a + b);
        totalSum = totalSum + allSum
      })
      // if allSum is equals to zero the datas should be empty
      // else call the multi data function
      if (totalSum == 0) {
        this.datas = [];
        this.showGraph = true;
      } else {
        this.datas = dealWonLostRes;
        this.multiDataValues(this.datas);
      }
    })
  }

  dealWinQ(data) {
    const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
    data.forEach((m, i) => {
      const q = this.dateUtil.getQuarter(i)
      let count = quarters[q];
      if (count || count === 0) {
        count = m + count
      }
      quarters[q] = count;
    });
    const result = [];
    Object.values(quarters).forEach(q => result.push(q))
    this.won = result;
  }

  dealLostQ(data) {
    const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
    data.forEach((m, i) => {
      const q = this.dateUtil.getQuarter(i)
      let count = quarters[q];
      if (count || count === 0) {
        count = m + count
      }
      quarters[q] = count;
    });
    const result = [];
    Object.values(quarters).forEach(q => result.push(q))
    this.lost = result;
  }

  dealTotalQ(data) {
    const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
    data.forEach((m, i) => {
      const q = this.dateUtil.getQuarter(i)
      let count = quarters[q];
      if (count || count === 0) {
        count = m + count
      }
      quarters[q] = count;
    });
    const result = [];
    Object.values(quarters).forEach(q => result.push(q))
    this.total = result;
  }

  /**
   * Singles data value
   * @param responses 
   * this is to load the chart when there is value
   */
  singleDataValue(responses) {
    if (responses[0]) {
      const dealWL = responses[0]
      const winMap: any = dealWL.map(w => w.size)
      const lostMap = dealWL.map(l => l.total)
      const totalMap = dealWL.map(t => t.all)
      if (this.selectedPeriod === 'quaterly') {
        const quatersLabel = ['Q1', 'Q2', 'Q3', 'Q4'];
        this.dealLostQ(lostMap);
        this.dealWinQ(winMap);
        this.dealTotalQ(totalMap);
        this.chartOptions.xaxis.title.text = "Quaters";
        this.chartOptions.xaxis.categories = quatersLabel;
        this.chartOptions.series[0].data = this.total;
        this.chartOptions.series[1].data = this.won;
        this.chartOptions.series[2].data = this.lost;
      } else {
        this.chartOptions.series[0].data = totalMap;
        this.chartOptions.series[1].data = winMap;
        this.chartOptions.series[2].data = lostMap;
        this.chartOptions.xaxis.categories = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
          this.chartOptions.xaxis.title.text = "Months";
      }
    }
    this.showGraph = true;
  }

  multiDataValues(dealWonLostRes) {
    const multiSalesPTeamsWonLostObj = {};
    const multiSalesPTeamsWonLost = [];
    if (this.selectedPeriod === 'quaterly') {
      dealWonLostRes.forEach(deal => {
        const totalMap = deal.values.map(t => t.all);
        const lostMap = deal.values.map(l => l.total);
        const wonMap = deal.values.map(w => w.size);
        if (multiSalesPTeamsWonLostObj[deal.key]) {
          const salesDeal = multiSalesPTeamsWonLostObj[deal.key];
          multiSalesPTeamsWonLostObj[deal.key] = {
            ...salesDeal, id: deal.key,
            total: this.dateUtil.getQuarterlyData(totalMap).quartersObj,
            lost: this.dateUtil.getQuarterlyData(lostMap).quartersObj,
            won: this.dateUtil.getQuarterlyData(wonMap).quartersObj,
          }
        } else {
          multiSalesPTeamsWonLostObj[deal.key] = {
            id: deal.key,
            name: `${this.selectedNames[deal.key].name}`,
            total: this.dateUtil.getQuarterlyData(totalMap).quartersObj,
            lost: this.dateUtil.getQuarterlyData(lostMap).quartersObj,
            won: this.dateUtil.getQuarterlyData(wonMap).quartersObj,
          };
        }
        multiSalesPTeamsWonLost.push({ name: `${this.selectedNames[deal.key].name}`, ...deal });

      });
      const res = [];
      Object.keys(multiSalesPTeamsWonLostObj).forEach(x => {
        res.push(multiSalesPTeamsWonLostObj[x])
      });
      this.dataTable = res;
    } else {
      dealWonLostRes.forEach(deal => {
        const name = this.selectedNames[deal.key] ? `${this.selectedNames[deal.key].name}` : null;
        if (multiSalesPTeamsWonLostObj[deal.key]) {
          const salesDeal = multiSalesPTeamsWonLostObj[deal.key];
          multiSalesPTeamsWonLostObj[deal.key] = { ...salesDeal, id: deal.key, total: deal.values.map(t => t.all), lost: deal.values.map(l => l.total), won: deal.values.map(w => w.size) }
        } else {
          multiSalesPTeamsWonLostObj[deal.key] = { id: deal.key, name, total: deal.values.map(t => t.all), lost: deal.values.map(l => l.total), won: deal.values.map(w => w.size) };
        }
        multiSalesPTeamsWonLost.push({ name, ...deal })
      });
      const res = [];
      Object.keys(multiSalesPTeamsWonLostObj).forEach(x => {
        res.push(multiSalesPTeamsWonLostObj[x])
      });
      this.dataTable = res;
    }
    this.showGraph = true;
  }

  resetGraph() {
    this.chartOptions.series[0].data = [];
    this.chartOptions.series[1].data = [];
    this.chartOptions.series[2].data = [];
    this.showGraph = false;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
